import { FC, ReactNode } from "react";
import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import Divider from "@mui/material/Divider";
import { SlideUpFade } from "./SlideUpFade";

interface FiltersModalProps {
  open: boolean;
  onClose: () => void;
  /** The filters sidebar + active filter editor, rendered side-by-side. */
  children: ReactNode;
  /** Sticky action bar rendered full-width below the sidebar + editor. */
  footer?: ReactNode;
}

/**
 * Hosts the filter UI (category list + active-filter editor) in a centered
 * modal. Enters and exits with a quick slide (10px) + fade; the backdrop fades.
 * An optional footer pins actions (e.g. "Confirm filters") below the content.
 */
export const FiltersModal: FC<FiltersModalProps> = ({
  open,
  onClose,
  children,
  footer,
}) => (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth={false}
    TransitionComponent={SlideUpFade}
    transitionDuration={{ enter: 200, exit: 160 }}
    data-testid="filters-modal"
    slotProps={{
      paper: {
        sx: {
          width: { xs: "94vw", md: 920 },
          height: "82vh",
          maxHeight: 760,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          borderRadius: 2,
          boxShadow: 24,
        },
      },
    }}
  >
    <Box
      sx={{
        flex: 1,
        minHeight: 0,
        display: "flex",
        flexDirection: "row",
        overflow: "hidden",
      }}
    >
      {children}
    </Box>
    {footer && (
      <>
        <Divider />
        <Box sx={{ flexShrink: 0, bgcolor: "background.paper" }}>{footer}</Box>
      </>
    )}
  </Dialog>
);
